import Page from './user-restore.container';

export default Page;
